import React from 'react';
import PropTypes from 'prop-types';

import { isBoardgameAvailable } from '../utilities';

import PlayTime from './PlayTime';
import Players from './Players';
import IconSadFace from './IconSadFace';



const BoardgameListItem = ({ boardgame, onClick }) => {
  return (
    <div className="w-full cursor-pointer" onClick={() => onClick && onClick(boardgame.id)}>
      <div className="flex h-26 md:h-auto w-full py-6 md:py-0 md:rounded-lg md:shadow-md md:flex-col items-center md:items-start">
        <div className="h-18 w-18 md:h-64 md:w-full bg-cover bg-no-repeat bg-top rounded-lg md:rounded-b-none shadow-md md:shadow-none relative" style={{backgroundImage: `url("${boardgame.image}")`}}>
          {
            !isBoardgameAvailable(boardgame.availableCopies, boardgame.reservedCopies) &&
              <div className="absolute rounded-lg md:rounded-b-none h-full w-full flex flex-col justify-center items-center">
                <div className="absolute rounded-lg md:rounded-b-none h-full w-full bg-gray-700 opacity-75"></div>
                <IconSadFace className="z-10 w-1/4 h-1/4" fill="#FFFFFF" />
              </div>
          }
        </div>
        <div className="flex flex-col h-24 md:w-full md:bg-white md:px-4 ml-4 mr-2 md:ml-0 md:rounded-b-lg md:mr-0 py-4 flex-1 justify-center">
          <h1 className="font-serif font-black text-lg leading-tight">
            { boardgame.title }
          </h1>
          <div className="flex mt-2">
            <PlayTime minPlayTime={boardgame.minPlayTime} maxPlayTime={boardgame.maxPlayTime} iconSize={18} marginClasses="mr-3" />
            <Players minPlayers={boardgame.minPlayers} maxPlayers={boardgame.maxPlayers} iconSize={18} />
          </div>
        </div>
        <svg className="md:hidden" xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24">
          <path d="M7.33 24l-2.83-2.829 9.339-9.175-9.339-9.167 2.83-2.829 12.17 11.996z"/>
        </svg>
      </div>
    </div>
  );
};

BoardgameListItem.propTypes = {
  boardgame: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    minPlayTime: PropTypes.number.isRequired,
    maxPlayTime: PropTypes.number,
    minPlayers: PropTypes.number.isRequired,
    maxPlayers: PropTypes.number,
    availableCopies: PropTypes.number.isRequired,
    reservedCopies: PropTypes.number,
  }).isRequired,
  onClick: PropTypes.func,
};

export default BoardgameListItem;